import { makeMutation } from '@core/queries';

export const createUnownedPlatformContexts = makeMutation<{ createUnownedPlatformContexts: boolean }>(`
mutation CreateUnownedPlatformContexts {
    createUnownedPlatformContexts
}
`);
